<template>
    <div class="tab_content">
        <div class="search_box clearfix">
            <div class="search_time search_inputBox">
               <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
               ~
               <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.salesman_id" clearable placeholder="销售人" @visible-change="getSalemanList">
                <el-option v-for="list in saleManList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.brand_id" clearable placeholder="品牌" @visible-change="getBrandList">
                <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.breed_id" clearable placeholder="品名" @visible-change="getBreedList">
                <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.grade_id" clearable placeholder="等级" @visible-change="getGradeList">
                <el-option v-for="list in gradeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <div class="reset fcolor" @click="reset">重置</div>
            <el-button  class="publicBtn" @click="search">查询</el-button>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="report.order.salesman" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
        </div>
        <div class="text-center">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber" v-if="statistics.out_cube">出库方数：{{statistics.out_cube }}m³</div>
            <div class="totalNumber" v-if="statistics.sales_cube">销售方数: {{statistics.sales_cube }}m³</div>
            <div class="totalNumber" v-if="statistics.sales_amount">销售金额：¥{{statistics.sales_amount }}</div>
            <div class="totalNumber" v-if="statistics.purchase_amount">采购金额：¥{{statistics.purchase_amount }}</div>
            <div class="totalNumber" v-if="statistics.cost_amount">成本费用：¥{{statistics.cost_amount }}</div>
            <div class="totalNumber" v-if="statistics.reduce_amount">优惠金额: ¥{{statistics.reduce_amount }}</div>
            <div class="totalNumber" v-if="statistics.business_expense">营业支出: ¥{{statistics.business_expense }}</div>
            <div class="totalNumber" v-if="statistics.sales_margin">销售利润: ¥{{statistics.sales_margin }}</div>
        </div>
        <filter-fields :tableData="filter" scene="report.order.salesman" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
    </div>
</template>
<style scoped lang="scss">
    .totalNumber{margin-right: 10px;}
    .totalName{margin-right: 10px;}
    // .container{ }
</style>
<script>
import tabletem from '../../../components/table.vue'
import pagination from '../../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                tableLoading:false,
                start_time: "",
                end_time: "",
                params : {
                    page : 1,
                    per_page : 50,
                    search : {
                        start_time : "",
                        end_time : "",
                        salesman_id : "",
                        breed_id : "",
                        brand_id : "",
                        grade_id : "",
                    }
                },
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    count  : "",
                    sales_cube  : "",
                    sales_amount  : "",
                },
                brandList : [],
                breedList : [],
                gradeList : [],
                saleManList : [],

                list:[],
                tableCol:[
                    {colName:"销售人",colKey:"salesman_name",colWidth:81,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"件数",colKey:"count",colWidth:63,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"方数",colKey:"sales_cube",colWidth:83,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成本费用",colKey:"cost_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"优惠金额",colKey:"reduce_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"营业支出",colKey:"business_expense",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售利润",colKey:"sales_margin",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"利润率",colKey:"margin_rate",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                filterDialogVisible:false,
                filter:"",
                fields:"",
            }
        },
        created(){
            this.start_time = this.$getCurrentMonthStartValueOf();
            this.end_time = new Date();
        },
        methods:{
            exportExcelBill(){
                this.$exportExecl("/erp/export.summarizing.sales.man","销售汇总(销售员)",this.params)
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableLoading = true;
                this.$postColumnList("/erp/report.order.salesman",this.params,response=>{
                    this.list = response.data.data.list;
                    this.filter = response.data.data.column;
                    this.fields=","+(response.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                    })
                    this.total = response.data.data.total;
                    this.statistics = response.data.data.statistics;
                    this.last_page = response.data.data.last_page;
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                })
            },
            filterConfirm(){
                this.getList()
            },
            search(){
                this.params.search.start_time = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                this.params.search.end_time = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);

                this.params.search.start_time = this.formatTimeZero(this.start_time);
                this.params.search.end_time = this.formatTimeZero(this.end_time);
                this.tableColCopy = this.$deepClone(this.tableCol);
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
                this.params.search = {
                    start_time : "",
                    end_time : "",
                    salesman_id : "",
                    breed_id : "",
                    brand_id : "",
                    grade_id : "",
                }
                this.search();
            },

            // 品名
            getBreedList(visible){
                if(visible){
                    this.$getBreedList().then(res=>{
                        this.breedList = res.data.data;
                    })
                }
            },
            // 品牌
            getBrandList(visible){
                if(visible){
                    this.$getBrandList().then(res=>{
                        this.brandList = res.data.data;
                    })
                }
            },
            // 等级
            getGradeList(visible){
                if(visible){
                    this.$getGradeList().then(res=>{
                        this.gradeList = res.data.data;
                    })
                }
            },
            // 获取销售员
            getSalemanList(visible){
                if(visible){
                    this.$getSalemanList('',1).then(res=>{
                        this.saleManList = res.data.data;
                    })
                }
            }
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
